import { Component, input, InputSignal } from '@angular/core';

/**
 * Marks a row of the comparison block as deviating from the order (UC_2026).
 *
 * <p>Only the marker: invoice value, order value and difference stand in their own columns as visible
 * text, so the information is never locked inside a tooltip. The icon therefore needs no keyboard
 * focus of its own — it carries an accessible name and nothing else, which keeps a 40-position
 * invoice from growing a tab stop per compared field.
 */
@Component({
    selector: 'invoice-item-deviation',
    imports: [],
    templateUrl: './invoice-item-deviation.component.html',
})
export class InvoiceItemDeviationComponent {
    /** Already translated accessible name of the marker. */
    public readonly hint: InputSignal<string> = input.required<string>();
}
